import { SkeletonLoader, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const LoadingSkeleton = styled(SkeletonLoader).attrs({
  areas: [
    {
      styles: {
        width: '100%',
        height: 'calc(100vh - 80px)',
        borderRadius: '8px',
      },
    },
  ],
})`
  height: 100%;
  padding: 20px;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const Title = styled.div`
  ${typographyV2.titleLg};
`;
